import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IssuerService } from '../service/issuer.service';

@Injectable({
    providedIn: 'root'
})
export class IssuerValidators
{
    constructor(private issuerService: IssuerService) { }

    public validateIssuerNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.issuerService.existsIssuerName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
